import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ResultPage } from '@core/data/models/result-page.model';
import { TenantOption } from '..';

@Injectable({ providedIn: 'root' })
export class TenantOptionService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/tenants`;

  loadList(): Observable<TenantOption[]> {
    return this.http
      .get<ResultPage<TenantOption>>(this.baseUrl)
      .pipe(map((page) => page.result));
  }
}
